import { RaceTrack, TrackLocation } from "@tvg/ts-types/Race";
import { truncate } from "lodash";
import { TRACK_NAME_MAX_LENGTH } from "./constants";

export const buildQALabel = (labels: string[]) =>
  labels.filter(Boolean).join("-");

export const getFlagLabel = (location?: TrackLocation) => {
  if (location?.country === "USA" && location?.state) return location?.state;
  return location?.country ?? "";
};

export const getSpecialPickTrackName = (
  track: Pick<RaceTrack, "name" | "shortName">
) => {
  if (track.name.length <= TRACK_NAME_MAX_LENGTH) {
    return track.name;
  }

  if (track.shortName && track.shortName.length <= TRACK_NAME_MAX_LENGTH) {
    return track.shortName;
  }

  return truncate(track.shortName || track.name, {
    length: TRACK_NAME_MAX_LENGTH
  });
};
